import { render, staticRenderFns } from "./wonderful-activity.vue?vue&type=template&id=2290de58&scoped=true&"
import script from "./wonderful-activity.vue?vue&type=script&lang=js&"
export * from "./wonderful-activity.vue?vue&type=script&lang=js&"
import style0 from "./wonderful-activity.vue?vue&type=style&index=0&id=2290de58&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2290de58",
  null
  
)

export default component.exports